import { Breadcrumb } from '@components/common/breadcrumb';
import { DestinationLinkBuilder, Name } from '@model/iceberg/geography';
import { withTheme } from '@emotion/react';
import React from 'react';
import { useI18NextContext } from '@components/hooks';
import { Item } from '@components/breadcrumbs/item';
import { TripTypes } from '@model/common';

export interface ResortsBreadcrumbProps {
  destination: Name;
}

export const ResortsBreadcrumbComponent = ({ destination }: ResortsBreadcrumbProps) => {
  const builder: DestinationLinkBuilder = new DestinationLinkBuilder();
  const t: any = useI18NextContext();
  const items: Array<Item> = [
    { ...builder.getDestinationLink(destination.path, TripTypes.HOLIDAYS), display: destination.display },
    { as: '', href: '', display: t('common__label--resorts-in', { destination: destination.display }) }
  ];
  return <Breadcrumb items={items} />;
};

export const ResortsBreadcrumb = withTheme(ResortsBreadcrumbComponent);
